<script lang="ts">
  import { currentQuestion, surveyStatus } from '../../stores'
  import type { Answer } from '../../types/question'

  let current: Answer[] = $surveyStatus.currentUserAnswer ? $surveyStatus.currentUserAnswer : []

  let openAnswerIndex = $surveyStatus.currentUserAnswer.findIndex((el) => el.isOpenAnswer === true)

  let currentOpenAnswer = $surveyStatus.currentUserAnswer?.[openAnswerIndex]?.openAnswerText
    ? $surveyStatus.currentUserAnswer[openAnswerIndex].openAnswerText
    : null

  $: {
    $surveyStatus.currentUserAnswer = current
    openAnswerIndex = $surveyStatus.currentUserAnswer.findIndex((el) => el.isOpenAnswer === true)

    if ($surveyStatus.currentUserAnswer[openAnswerIndex]) {
      $surveyStatus.currentUserAnswer[openAnswerIndex].openAnswerText = currentOpenAnswer
    }

    $surveyStatus = $surveyStatus
  }
</script>

<svelte:window
  on:keydown={(event) => {
    if (event.key === 'ArrowRight' && event.altKey) {
      event.preventDefault()
      current = $currentQuestion.answers.slice(0, 3)
    }
  }}
/>

{#each $currentQuestion.answers as answer}
  <label>
    <input
      type="checkbox"
      bind:group={current}
      value={answer}
      disabled={current.length >= $currentQuestion.maxAnswersNumber &&
        !current.some((c) => c.text === answer.text)}
    />
    <div>
      {answer.text}
      {#if answer.isOpenAnswer && current.includes(answer)}
        <br />
        <div class="separator" />
        <input
          type="text"
          placeholder="Scrivi la tua risposta..."
          bind:value={currentOpenAnswer}
          maxlength="100"
        />
      {/if}
    </div>
  </label>
{/each}

<style>
  label {
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    gap: 1rem;
  }
  input[type='checkbox'] {
    cursor: pointer;
    -webkit-appearance: none;
    background-color: transparent;
    border: 1px solid white;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    margin: 0;
    min-width: 20px;
    height: 20px;
  }

  input[type='checkbox']:checked {
    background: url('../img/checkmark.svg') #00fff0 no-repeat center center;
    border: none;
  }

  input[type='checkbox']:disabled {
    background-color: #2d2d2d;
    border-color: #676767;
  }
  input[type='text'] {
    height: 25px;
    margin: 0;
    font-size: inherit;
    background-color: transparent;
    border: 0;
    border-bottom: 1px solid white;
    border-radius: 0;
    color: #7b7b7b;
  }
  input[type='text']:focus-visible {
    outline: 0;
  }
  .separator {
    height: 10px;
  }
</style>
